import { FlaskConical } from "lucide-react";
import { useTranslation } from "react-i18next";

export function BetaBanner() {
	const { t } = useTranslation();

	return (
		<div
			className="shrink-0 flex items-center justify-center gap-2 px-4 py-2 text-center text-xs font-medium"
			style={{
				background: "rgba(139, 92, 246, 0.16)",
				borderBottom: "1px solid rgba(167, 139, 250, 0.34)",
				color: "#ddd6fe",
			}}
		>
			<FlaskConical size={15} aria-hidden="true" className="shrink-0" />
			<span>{t("betaBanner.message")}</span>
		</div>
	);
}
